import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import loadable from "@loadable/component";
const CountdownTimer = loadable(
  () => import(/* webpackChunkName: "CountdownTimer" */ "./CountDownTimer"),
  { ssr: false }
);

const Timer = styled.div`
  box-shadow: 0 30px 80px 0 rgba(153, 51, 51, 0);
  background-color: #e8f8fd;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(16, 159, 209, 0.72);
  border-radius: ${props => props.borderRadius};
  padding: ${props => props.padding};
  margin-top: ${props => (props.noMargin ? "0px" : "10px")};
  display: grid;
  grid-template-columns: 1fr 175px 1fr;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const IconSpan = styled.span`
  margin-right: 10px;
  height: 100%;
  justify-self: flex-end;
  display: flex;
`;

const TimeSpan = styled.span`
  color: #109fd1;
`;

const TextSpan = styled.span`
  grid-column: 2/3;
  display: flex;
  align-items: center;
  height: 100%;
`;

const Refresh = styled.span`
  color: #109fd1;
  cursor: pointer;
  font-size: 12px;
  justify-self: center;
  grid-column: 3/4;
`;

const CountDownClock = ({ timeStamp, borderRadius, padding, noMargin }) => {
  const [spinnerClass, changeSpinnerClass] = useState("");
  const [showRefresh, changeShowRefresh] = useState(
    (timeStamp - Date.now()) / 1000 / 60
  );
  useEffect(() => {
    changeShowRefresh((timeStamp - Date.now()) / 1000 / 60);
    const interval = setInterval(() => {
      if ((timeStamp - Date.now()) / 1000 / 60 < 5) {
        changeShowRefresh((timeStamp - Date.now()) / 1000 / 60);
        changeSpinnerClass("");
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [timeStamp]);

  return (
    <Timer
      borderRadius={borderRadius}
      padding={padding}
      noMargin={noMargin}
      className="countdown-clock-main"
    >
      <TextSpan>
        <IconSpan>
          <img
            src="https://cdn.cardcash.com/website/ui/elements/timer-cart2.svg"
            alt="timer"
          />
        </IconSpan>
        Cart saved for&nbsp;
        <TimeSpan>
          <CountdownTimer />
        </TimeSpan>
      </TextSpan>
      {showRefresh < 5 && (
        <Refresh
          onClick={async () => {
            changeSpinnerClass("spinner-rotate");
            await sessionState.renewSession();
          }}
        >
          <img
            src="https://cdn.cardcash.com/website/ui/elements/refresh-blue.svg"
            className={spinnerClass}
            alt="refresh session"
          />
        </Refresh>
      )}
    </Timer>
  );
};

export default CountDownClock;
